import React, { useEffect, useMemo, useState } from 'react';
import { Column, Row } from 'react-table';

import { AdminVoucherCategoryDto, UserInfoDto } from 'services/data-contracts';
import TableBody from 'components/table/TableBody';
import { EditButton } from 'resources/styles/TableStyle';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import PaginationWrapper from '../Pagination';
import { useStoreWrapper } from 'stores/StoreHelper';

interface VoucherGroupTableProps {
  voucherCategories: AdminVoucherCategoryDto[];
  onRowClick?: (voucherGroup: AdminVoucherCategoryDto) => void;
  onEditClick?: (voucherGroup: AdminVoucherCategoryDto) => void;
}


// 테이블 데이터 타입 정의
const VoucherCategoryTable = observer(({ voucherCategories, onRowClick, onEditClick }: VoucherGroupTableProps) => {
  const { voucherFilterStore } = useStoreWrapper();

  // 테이블 컬럼 정의
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'id' as keyof AdminVoucherCategoryDto,
        width: 60,
      },
      {
        Header: '카테고리명',
        accessor: 'localizedName' as keyof AdminVoucherCategoryDto,
        width: 100,
        Cell: ({ value }: { value: Record<string, string> }) => {
          return value && value['ko'] ? value['ko'] : '임시 타이틀';
        },
      },
      {
        Header: '카테고리 설명',
        accessor: 'localizedDesc' as keyof AdminVoucherCategoryDto,
        width: 100,
        Cell: ({ value }: { value: Record<string, string> }) => {
          return value && value['ko'] ? value['ko'] : '임시 설명입니다.  ';
        },
      },
      {
        Header: '생성자',
        accessor: 'creator.username' as keyof AdminVoucherCategoryDto,
        width: 200,
      },
      {
        Header: '생성일',
        accessor: 'createDate' as keyof AdminVoucherCategoryDto,
        width: 120,
        Cell: ({ value }: { value: string }) => {
          const date = new Date(value);
          return date.toLocaleDateString('ko-KR');
        },
      },
      {
        Header: '수정',
        id: 'edit',
        width: 80,
        Cell: ({ row }: { row: Row<AdminVoucherCategoryDto> }) => <EditButton onClick={(e) => {
          e.stopPropagation();
          onEditClick?.(row.original as AdminVoucherCategoryDto);
        }}>수정</EditButton>,
      },
    ],
    [],
  ) as Column<UserInfoDto>[];

  return (
    <div>
      <div style={{ paddingBottom: '100px' }}>
        <TableBody columns={columns} data={voucherCategories} onRowClick={onRowClick} />
      </div>
      <PaginationContainer>
        <PaginationWrapper count={voucherFilterStore.paginationInfo?.totalCount ?? 0}
          totalPages={voucherFilterStore.paginationInfo?.totalPages ?? 0} />
      </PaginationContainer>
    </div>
  );
});

const PaginationContainer = styled.div`
    margin-top: 20px;
    position:fixed;
    bottom:0;
    z-index:10;
    margin:auto;
    background:rgba(255,255,255,1);
    backdrop-filter: blur(10px);
    left:0;
    right:0;

    display:flex;
    justify-content:center;
    align-items:center;

`;

export default VoucherCategoryTable;
